import React from 'react';
import { PagesFragment } from '../../../generated/graphql';

import { Header } from './Header';

interface Props {
  page: PagesFragment;
  open?: boolean;
  toggleOpen?: () => void;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  previewOnClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  subHeadOnClick?: (event: React.MouseEvent<HTMLButtonElement>) => Promise<void>;
  guidance?: boolean;
  hasDropdown?: boolean;
  toggleVisibility?: () => void;
  removePage: (() => Promise<void>) | null;
}

const CUSTOM_PAGE_TYPE = 'CustomPage';

export const CardHeader: React.FC<Props> = ({
  page,
  onClick,
  previewOnClick,
  subHeadOnClick,
  open,
  toggleOpen,
  guidance = false,
  hasDropdown = true,
  toggleVisibility,
  removePage,
}) => {
  const statusText = page.show ? undefined : 'Hidden';
  const titleText = page.title || '';
  const subHeadText = page.pageGuidance?.visiblePageDescription || '';
  const pageType = page.type;
  const customPage = page.type === CUSTOM_PAGE_TYPE;

  const headerProps = {
    titleText,
    statusText,
    onClick,
    previewOnClick,
    subHeadOnClick,
    open,
    toggleOpen,
    guidance,
    hasDropdown,
    subHeadText,
    toggleVisibility,
    removePage,
    pageType,
    customPage,
    as: 'h2',
  };

  return <Header {...headerProps} />;
};
